// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {citySetItem, cityAddItem, areaGetItem,cityGetItem} from '../../actions/areaActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/area/AddEditCityForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, areaConstants,commonConstants} from "../../constants";
import {reset} from 'redux-form';

const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.area.cityGetItem,
        userValue: state.app.currentUser,
        areaList : state.area.areaList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getAreaStateList : () => {
        dispatch(areaStateList());
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode === 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title'         : values.title,
            'code'          : parseInt(values.code),
            'stateId'       : values.stateId,
            'commission'    : parseInt(values.commission),
            'commuting_fee' : parseInt(values.commuting_fee)
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('/area/city', formData).then(list => {
            dispatch(cityAddItem(list.data.lists));
            if(list.data.status === true) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addCity'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title'         : values.title,
            'code'          : values.code,
            'stateId'       : values.state._id,
            'commission'    : parseInt(values.commission),
            'commuting_fee' : parseInt(values.commuting_fee)
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('area/city/'+id, formData).then(editRes => {
            dispatch(citySetItem(editRes.data));
            if(editRes.data.result === true) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('area/city/'+id).then(cityInfo => {
            dispatch(cityGetItem(cityInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}

const areaStateList = () => {
    return (dispatch, getState) => {
        API_FETCH.get('area').then(areaList => {
            dispatch(areaGetItem(areaList.data.lists));
        }).catch(error => {
            console.log(error);
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
